import { render, staticRenderFns } from "./newsListPC.vue?vue&type=template&id=2cc2558c&scoped=true"
import script from "./newsListPC.vue?vue&type=script&lang=js"
export * from "./newsListPC.vue?vue&type=script&lang=js"
import style0 from "./newsListPC.vue?vue&type=style&index=0&id=2cc2558c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc2558c",
  null
  
)

export default component.exports